import { NPKCatalogs } from "@smartdevis/server/src/domain";
import { requestData } from "../../../../services/server";
import { Authentication } from "../../../../store/authState";

export const getLicenceUnlockInfo = (auth: Authentication, body: Pick<NPKCatalogs.Credentails, 'customerID' | 'licenseID' | 'workStationID'>) =>
    requestData<NPKCatalogs.LicenseUnlockInfo>("authorized", {
        path: "/crb/License/getLicenceUnlockInfo",
        auth,
        validators: [],
        isV2: true,
        reqMethod: "POST",
        body
    })


export const getLicenceInfo = (auth: Authentication, body: Pick<NPKCatalogs.Credentails, 'customerID' | 'licenseID'>) =>
    requestData<NPKCatalogs.LicenceInfo>("authorized", {
        path: "/crb/License/getLicenceInfo",
        auth,
        validators: [],
        isV2: true,
        reqMethod: "POST",
        body
    })

export const getLicenceIDs = (auth: Authentication, body: Pick<NPKCatalogs.Credentails, 'customerID' | 'licenseID'>) =>
    requestData<NPKCatalogs.LicenseIds>("authorized", {
        path: "/crb/License/getLicenceIDs",
        auth,
        validators: [],
        isV2: true,
        reqMethod: "POST",
        body
    })


export const getSubscribedWorkStations = (auth: Authentication, body: Pick<NPKCatalogs.Credentails, 'customerID' | 'licenseID'>) =>
    requestData<NPKCatalogs.Workstation[]>("authorized", {
        path: "/crb/License/getSubscribedWorkStations",
        auth,
        validators: [],
        isV2: true,
        reqMethod: "POST",
        body
    })

export const unSubscribeWorkStation = (auth: Authentication, body: Pick<NPKCatalogs.Credentails, 'customerID' | 'licenseID' | 'workStationID'>) =>
    requestData<{}>("authorized", {
        path: "/crb/License/unSubscribeWorkStation",
        auth,
        validators: [],
        isV2: true,
        reqMethod: "POST",
        body
    })



export const loginWithLicenceUnlockInfo = (auth: Authentication, body: Pick<NPKCatalogs.LicenseUnlockInfo, 'signature'> & { licenceUnlockInfo: string }) =>
    requestData<NPKCatalogs.AccessStatus>("authorized", {
        path: "/crb/Partner/getLoginWithLicenceUnlockInfo",
        auth,
        validators: [],
        isV2: true,
        reqMethod: "POST",
        body
    })

export const getUnitsOfMeasure = (auth: Authentication, body: { language: NPKCatalogs.TLanguage, year: string }) =>
    requestData<Array<NPKCatalogs.NPKUnits>>("authorized", {
        path: "/crb/Partner/getUnitsOfMeasure",
        auth,
        validators: [],
        isV2: true,
        reqMethod: "POST",
        body
    })

export const getNPKVersionYears = (auth: Authentication) =>
    requestData<Array<number>>("authorized", {
        path: "/crb/Partner/getNPKVersionYears",
        auth,
        validators: [],
        isV2: true,
        reqMethod: "POST",
        body: {}
    })


export const getNPKVersions = (auth: Authentication, body: { language: NPKCatalogs.TLanguage, chapter: string }) =>
    requestData<Array<NPKCatalogs.NPKChapterVersion>>("authorized", {
        path: "/crb/Partner/getNPKVersions",
        auth,
        validators: [],
        isV2: true,
        reqMethod: "POST",
        body
    })


// export const getNPKChapters = (auth: Authentication, body: { displayLanguage: NPKCatalogs.TLanguage }) =>
//     requestData<Array<NPKCatalogs.NPKChapterVersion>>("authorized", {
//         path: "/crb/Partner/getNPKChapters",
//         auth,
//         validators: [],
//         isV2: true,
//         reqMethod: "POST",
//         body
//     })

export const getNPKChaptersForYear = (auth: Authentication, body: { displayLanguage: NPKCatalogs.TLanguage, year: string }) =>
    requestData<Array<Pick<NPKCatalogs.Chapter, 'number' | 'display'>>>("authorized", {
        path: "/crb/Partner/getNPKChaptersForYear",
        auth,
        validators: [],
        isV2: true,
        reqMethod: "POST",
        body
    })

// export const DownloadNPKGliederung = (auth: Authentication, body: { language: NPKCatalogs.TLanguage, year: string }) =>
//     requestData<Array<NPKCatalogs.NPKChapterVersion>>("authorized", {
//         path: "/crb/Partner/DownloadNPKGliederung",
//         auth,
//         validators: [],
//         isV2: true,
//         reqMethod: "POST",
//         body
//     })

export const downloadNPK = (auth: Authentication, body: { language: NPKCatalogs.TLanguage, year: string, chapter: string }) =>
    requestData<Array<NPKCatalogs.NPKChapter>>("authorized", {
        path: "/crb/Partner/downloadNPK",
        auth,
        validators: [],
        isV2: true,
        reqMethod: "POST",
        body
    })

export const getAllFileNames = (auth: Authentication, body: { language: NPKCatalogs.TLanguage, year: string }) =>
    requestData<Array<string>>("authorized", {
        path: "/crb/Partner/getAllFileNames",
        auth,
        validators: [],
        isV2: true,
        reqMethod: "POST",
        body
    })


export const downloadDrawing = (auth: Authentication, drawingId: string) =>
    requestData<NPKCatalogs.Drawing[]>("authorized", {
        path: "/crb/Partner/downloadDrawing",
        auth,
        validators: [],
        isV2: true,
        reqMethod: "POST",
        body: { drawingIDs: [drawingId] }
    })

export const downloadFile = (auth: Authentication, body: { language: NPKCatalogs.TLanguage, year: string, fileName: string }) =>
    requestData<Array<string>>("authorized", {
        path: "/crb/Partner/getAllFileNames",
        auth,
        validators: [],
        isV2: true,
        reqMethod: "POST",
        body
    })



export const getNPKLanguages = (auth: Authentication) =>
    requestData<NPKCatalogs.Languages>("authorized", {
        path: "/catalogs/GetLanguages",
        auth,
        validators: [],
        isV2: true,
        reqMethod: "GET"
    })


export const getNPKVersion = (auth: Authentication) =>
    requestData<NPKCatalogs.VersionYears>("authorized", {
        path: "/crb/Partner/getNPKVersionYears",
        auth,
        validators: [],
        isV2: true,
        reqMethod: "GET"
    })


export const getNPKChapters = (auth: Authentication, body: Pick<NPKCatalogs.Credentails, 'customerID' | 'licenseID' | 'workStationID'> & { userId: string }) =>
    requestData<NPKCatalogs.Chapters>("authorized", {
        path: "/catalogs/GetChapters",
        auth,
        validators: [],
        isV2: true,
        reqMethod: "POST",
        body
    })


export const getSectionsList = (auth: Authentication, body: NPKCatalogs.NPKChapterVersionRequest & { year: string }) =>
    requestData<Array<Pick<NPKCatalogs.Chapter, 'number' | 'display'>>>("authorized", {
        path: "/catalogs/GetChapterSectionList",
        auth,
        validators: [],
        isV2: true,
        reqMethod: "POST",
        body
    })


export const getChapterSection = (auth: Authentication, body: NPKCatalogs.NPKChapterVersionRequest & { year: string, sectionId:string }) =>
    requestData<NPKCatalogs.NPKNode>("authorized", {
        path: "/catalogs/GetChapterSection",
        auth,
        validators: [],
        isV2: true,
        reqMethod: "POST",
        body
    })
